import { SpaceActionsGroup } from "../types";
import {
  PersonalSettingsSpacesActionItem,
  PersonalSettingsSpacesGroup,
} from "./usePersonalSettingsSpacesGroupsStore/types";

export const isSpaceActionsGroup = (
  group: PersonalSettingsSpacesGroup
): group is SpaceActionsGroup => {
  return "actions" in group;
};

export const isActionItem = (
  item: PersonalSettingsSpacesGroup
): item is PersonalSettingsSpacesActionItem => {
  return "actionID" in item;
};
